import * as _throttle from 'lodash/throttle';

export default {
  methods: {
    async $_registerResize(ref) {
      await this.$nextTick();
      const resizeEditorMethod = _throttle(cb => window.addEventListener('resize', cb));
      resizeEditorMethod(() => {
        ref.editor.layout();
      });
    }
  }
};
